module.exports = __webpack_public_path__ + "img/4-white.7ac2526c.png";